import { cn } from '@/lib/utils';

const steps = [
    { number: 1, label: 'Select Supplier' },
    { number: 2, label: '' },
    { number: 3, label: '' },
];

export function Stepper({ activeStep }: { activeStep: number }) {
    return (
        <div className="flex items-center justify-center gap-0">
            {steps.map((step, index) => (
                <div key={step.number} className="flex items-center">
                    <div className="flex flex-col items-center">
                        <div
                            className={cn(
                                'h-8 w-8 rounded-full flex items-center justify-center text-sm font-medium border-2 transition-colors',
                                activeStep >= step.number
                                    ? 'border-primary bg-primary/10 text-primary'
                                    : 'border-border text-muted-foreground',
                            )}
                        >
                            {step.number}
                        </div>
                    </div>
                    {index < steps.length - 1 && (
                        <div
                            className={cn(
                                'w-16 border-t-2 border-dashed mx-1',
                                activeStep > step.number ? 'border-primary' : 'border-border',
                            )}
                        />
                    )}
                </div>
            ))}
        </div>
    );
}
